'use strict';
import compareWidget from '../compare-widget';
import productTile from '../product-tile';
import progress from '../progress';
import video from '../video';
import util from '../util';
import recommendations from './product/recommendations';
import backInStock from './product/backInStock';
import currentLayout from '../detect-layout';
import analytics from '../analytics';
import filterPanel from './mobileFilterPanel';

var currLayout = currentLayout.init(),
	isSortingEnabled = false;

function copyBottomResultHitsToTop() {
	if ($('.search-folder-content-list').length == 0) {
		$("#results-hits-top").html($("#results-hits-bottom .results-hits").html());
	}
}

//PLP wishlist heart icon
function wishListElem() {
	$('.plp-wishlist-icon').off().on('click', function () {
		var ajaxUrl;
		var _this = $(this);
		var currProductID = _this.attr('data-element-pid');
		var productInwishlist = _this.attr('data-item-in-wishlist');
		var data = {
			pid: currProductID
		};

		if (_this.hasClass("plp-active-wishlist")) {
			ajaxUrl = _this.attr('data-ajax-remove');
			_this.removeClass("plp-active-wishlist");
		} else {
			ajaxUrl = _this.attr('data-ajax-add');
			_this.addClass("plp-active-wishlist");
		}

		$.ajax({
				type: 'GET',
				url: ajaxUrl,
				data: data
			})
			.done(function (response) {});
	});
}

function productCarouselelem() {
	$('#product-list-page-carousel').length && $('#product-list-page-carousel').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: false
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
}

function getPageUpdateOnUrl() {
	$("#search-result-items").on('click', '.outer-wrapper', function(e) {
		 localStorage.setItem("productPositionLastClicked", $(this).attr("id"));
		 const url = new URL(window.location.toString().split('#')[0]);				
		 url.searchParams.set('page', $(this).data('page-number'));
		 url.searchParams.set('start', $(this).data('page-start'));
					 
		 window.history.replaceState(null, null, url+'#'+$(this).attr("id"));
	});
 };
  
function viewMoreClick() {
	// getting the hidden div, which is the placeholder for the next page
	var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
	// get url hidden in DOM
	var gridUrl = loadingPlaceHolder.attr('data-grid-url');

	if (loadingPlaceHolder.length === 1) {
		// switch state to 'loading'
		// - switches state, so the above selector is only matching once
		// - shows loading indicator
		loadingPlaceHolder.attr('data-loading-state', 'loading');
		loadingPlaceHolder.addClass('infinite-scroll-loading');

		$('.next-page .inline-lazy-loader').show();

		// named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
		var fillEndlessScrollChunk = function (html) {
			var newHtml = $(html);
			loadingPlaceHolder.removeClass('infinite-scroll-loading');
			loadingPlaceHolder.attr('data-loading-state', 'loaded');
			$('#results-hits-bottom').remove();
			if ($('.tutorial-listing').length > 0) {
				$('div.search-result-content .folder-content-list').append(newHtml);
			} else if ($('.order-history-wrap').length > 0) {
				$('div.order-history-results').append(newHtml);
			} else {
				$('div.search-result-content').append(newHtml);
			}

			// move all product tiles up to search grid to prevent arbitrary breaklines
			$(".tiles-container .outer-wrapper").appendTo("#search-result-items");

			// If category bottom image configured then append bottom-empty li at last position(Exclusive Page)
			if ($('.renderbottommotiveimage').length) {
				$('.renderbottommotiveimage').appendTo("#search-result-items");
			}
			viewMorePosition();

			//Remove when there is duplicate/empty search-result-items
			//$('#search-result-items.page-element').remove();
			
			if ($('.search-result-items').is(':empty')) { 
			    $('.search-result-items').remove();
			}

			$('img.product-image-initial').off().on('mouseenter mouseleave', function () {
				$(this).attr({
					src: $(this).attr('data-alt-src'),
					'data-alt-src': $(this).attr('src')
				});
			});
			// PLP wishlist heart icon
			wishListElem();
			// rebind the View More event
			$("#view-more").off().on("click", viewMoreClick);
			tileSelectSizeInit();
			$("select").selectmenu().selectmenu('refresh', true);
			$('.next-page .inline-lazy-loader').hide();
			
			//remove back-page non required element
			var backPageID = $("#search-result-items .outer-wrapper:last").attr("data-page-number");
			$('#backpage-'+backPageID).remove();			
		};

		// old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
		// it was removed to temporarily address RAP-2649
		if(gridUrl.length) {
			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: gridUrl,
				success: function (response) {
					// put response into cache
					try {
						sessionStorage['scroll-cache_' + gridUrl] = response;
						
					} catch (e) {
						// nothing to catch in case of out of memory of session storage
						// it will fall back to load via ajax
					}
					// update UI
					$('.next-page.pagination-buttons').remove(); // identifier to detect next page available or not
					$(".results-hits").remove();
					
					fillEndlessScrollChunk(response);
					copyBottomResultHitsToTop();
					productTile.init();
					productTile.initCarouselSwatches();
					ellipsifyContentDescInt();
					$(document).trigger("plpviewmore");
					video.initialize();
					getPageUpdateOnUrl();
					// rebind lazyLoadingObserver after DOM updated 
					setTimeout(updateIntersectionObserverHandler, 1000);
				}
			})
		}	
	}
}

/**
 * @private
 * @function 
 * @description allow to lazyload contents of PLP pages, search result pages and content pages
 */ 
function lazyLoadingObserver() {
	var targetElement,
		observer;
	// IntersectionObserver's config options
	var options = {
		root: null, // null represents viewport or provide DOM node
		rootMargin: "200px 0px 200px 0px", // works in clockwise direction
		threshold: 0.85 // starts oberving from 1px of target being visible in the view port [0, 0.1 = 10%, 0.5 = 50%... upto 1=100]
		
	};

	targetElement =	document.querySelector('.next-page');
	if(typeof(targetElement) != 'undefined' && targetElement != null && !!window.IntersectionObserver) {
		observer = new IntersectionObserver(lazyLoadingObserverHandler, options);
		observer.observe(targetElement);
	}
}

	function lazyLoadingObserverHandler(entries, observer) {
		if ( !$( ".next-page" ).hasClass( "temp-hide" ) ) {
			for (var entry of entries) {
				if (entry.intersectionRatio>= 0.85) {
					viewMoreClick(); 
				} 
			}
		}
	}
	

/**
 * @private
 * @function 
 * @description allow to lazyload contents of PLP pages, search result pages and content pages
 */ 
 function lazyLoadingBottomToTopObserver() {
	var totalHeight = $("#search-result-items .outer-wrapper:first").outerHeight() != undefined ? ($("#search-result-items .outer-wrapper:first").outerHeight()/2) : "200";
	totalHeight = totalHeight+"px 0px "+totalHeight+"px 0px";	
	var targetElement,
		observer;
	// IntersectionObserver's config options
	var options = {
		root: null, // null represents viewport or provide DOM node
		rootMargin: totalHeight, // works in clockwise direction
		threshold: 0.85  // starts oberving from 1px of target being visible in the view port [0, 0.1 = 10%, 0.5 = 50%... upto 1=100]
		
	};
	targetElement =	document.querySelector('.back-page');
		if(typeof(targetElement) != 'undefined' && targetElement != null && !!window.IntersectionObserver) {
			observer = new IntersectionObserver(lazyLoadingBottomToTopObserverHandler, options);
			observer.observe(targetElement);
		}
}

function updateIntersectionObserverHandler() {
		if (!!window.IntersectionObserver) { 
			lazyLoadingObserver();
			if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
				initPLPSliderHandler();
			}
			initializeProductColorShadesSliderHandler();
		}
	
}

/**
 * @function
 * @description loads trustpilot widget for mobile and desktop devices into the page, if the trustpilot widget exists and the loadFromElement method is available
 */
function trustPilot() {
    var isTablet = window.matchMedia("(max-width: 768px)").matches;
    var elementArray = $('.plp-trustpilot-wrapper .trustpilot-widget');

    if (elementArray.length > 0 && typeof window.Trustpilot !== 'undefined' && typeof window.Trustpilot.loadFromElement === 'function') {
        elementArray.each(function() {
            if ((isTablet && $(this).hasClass('trustpilot-mobile')) || 
                (!isTablet && $(this).hasClass('trustpilot-desktop'))) {
                window.Trustpilot.loadFromElement(this);
            }
        });
    }
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url, stickFilter) {
	var openDropdownIndex = $('.filter-dropdowns .dropdown.open').index(),
		filterDropdownScrollPosition = $('.filter-dropdown-wrapper').scrollTop();
	$('.ajax-loader.page-loader').show();
	progress.show($('.search-result-content'));
	$('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
		$(this).find('.filter-contents').addClass('active');
		// don't open filter panel when sorting option changed 
		if(isSortingEnabled) {
			$(this).find('.filter-contents').removeClass('active');
		}		
		if(openDropdownIndex > 0) {
			$('.filter-dropdowns .dropdown').eq(openDropdownIndex - 1).addClass('open');
		}
		trustPilot();
		compareWidget.init();
		productTile.init();
		productTile.initCarouselSwatches();
		progress.hide();
		history.pushState(undefined, '', url);
		//reinitialize the functions
		initializeEvents();
		// PLP wishlist heart icon
		wishListElem();
		$('img.product-image-initial').off().on('mouseenter mouseleave', function () {
			$(this).attr({
				src: $(this).attr('data-alt-src'),
				'data-alt-src': $(this).attr('src')
			});
		});
		productCarouselelem();
		if (stickFilter) {
			if ($(".shop-by-btn").length) {
				$(".shop-by-btn").trigger('click');
			}
		}
		tileSelectSizeInit();
		recommendations.init();
		/*$(".shop-by-btn").trigger('click');*/
		$("select").selectmenu().selectmenu('refresh', true);
		sortByDropdown();
		categoryCarousel();
		catShopByCollectionMenuInit();
		simpleSearchClearFunc();
		viewMorePosition();
		video.initialize();
		groupingSelector();
		bindFilterSortRefinement();
		if ($(".tutorial-listing").length > 0) {
			destroyCarouselTutorial();
			createCarouselTutorial();
			updateFolderDescriptionOnChange();
		}
		$('.product-tiles-holder').addClass('is-visible');
		$('.ajax-loader.page-loader').hide();
		// to restore lazyloading behavior
		updateIntersectionObserverHandler();
	});
}

function destroyCarouselTutorial() {
	if ($('.tutorial-carousel-slick').hasClass('slick-initialized')) {
		$('.tutorial-carousel-slick').slick('destroy');
	}
}

function createCarouselTutorial() {
	if ($('.tutorial-carousel-slick').length > 0) {
		$('.tutorial-carousel-slick').slick({
			arrows: true,
			dots: true,
			infinite: false
		});
	}
}

function sortByDropdown() {
	var gridSortHeader = $('#grid-sort-header, #grid-sort-header-redesign');
	if (gridSortHeader.length > 0) {
		if (window.innerWidth < 769) {
			gridSortHeader.selectmenu({
				classes: {
					"ui-selectmenu-menu": "sort-by-selectmenu"
				}
			});
		} else {
			setTimeout(function(){
				gridSortHeader.selectmenu('destroy').selectmenu({
					position: {
						my: 'right top',
						at: 'right+26 bottom',
						collision: "flip"
					}
				});
			}, 0);
		}
	}
}

function excludeCompoundAttributeRefinements(refineUrl) {
	var newUrl = refineUrl;

	var params = util.getQueryStringParams(refineUrl);
	Object.keys(params).forEach(function (paramName) {
		if (paramName.indexOf('prefv') === -1) {
			return;
		}

		var splitParam = params[paramName].split("|");
		newUrl = util.updateQueryStringParam(newUrl, paramName, splitParam[splitParam.length - 1]);
	});

	return newUrl;
}

if (!$('#shop-by-dropdown').hasClass('is-open')) {
	$('body').removeClass("sticky-body");
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
	
	var $main = $('#main');
	// compare checked
	$main.on('click', 'input[type="checkbox"].compare-check', function () {
		var cb = $(this);
		var tile = cb.closest('.product-tile');

		var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
		var itemImg = tile.find('.product-image a img').first();
		func({
			itemid: tile.data('itemid'),
			uuid: tile[0].id,
			img: itemImg,
			cb: cb
		});

	});

	// handle events for updating grid
	$main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
		// don't intercept for category and folder refinements, as well as unselectable
		if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
			return;
		}
		e.preventDefault();
		updateProductListing(this.href);
	});

	sortByDropdown();

	$main.on('change', '.items-per-page select', function () {
		var refineUrl = $(this).find('option:selected').val();
		if (refineUrl === 'INFINITE_SCROLL') {
			$('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
		} else {
			$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
			updateProductListing(refineUrl);
		}
	});

	$main.on('change', '.items-per-page select', function () {
		var refineUrl = $(this).find('option:selected').val();
		$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
		updateProductListing(refineUrl);
	});

	$('.category-tab-links select').on('change', function (e) {
		var $selected = $(this).find(":selected");
		var link = $selected.attr('href');

		if (link) {
			window.location.href = link;
		}
	});

	$(".close-shop-by").on('click', function (e) {
		e.preventDefault();
		$(".shop-by-btn").trigger("click");
	});

	$(".dropdown-panel-button").on('click', function () {
		$(".dropdown-pane").removeClass("is-open");
		$('body').removeClass("sticky-body");
		$(".mega-menu-logo-container").show();
		$(".scroll-top-wrapper").show();
	});

	$(".shop-by-btn").on('click', function () {
		$(".plp-product-grid-category").addClass("small-flyout");
		if (screen.width <= 767) {
			$(".mega-menu-logo-container").hide();
			$(".scroll-top-wrapper").hide();
		}
		$('body').addClass("sticky-body");
	});

	$(".close-shop-by").on('click', function () {
		$(".dropdown-pane").removeClass("is-open");
		$(".shop-by-btn").removeClass("hover");
		$(".plp-product-grid-category").removeClass("small-flyout");
		$(".mega-menu-logo-container").show();
		$(".scroll-top-wrapper").show();
		$('body').removeClass("sticky-body");
	});

	catShopByCollectionMenuInit();
}

$('a.plp-menu-anchor').on('click', function () {
	var _this = $(this);
	if (!_this.parent().hasClass('is-active')) {
		_this.closest('.dropdown-pane').find('.is-active .accordion-title').trigger('click');
	}
});

function bindFilterSortRefinement() {
	// handle sorting change
	$('#grid-sort-header, #grid-sort-header-redesign').on("selectmenuchange change", function (event) {
		event.preventDefault();
		isSortingEnabled = true;
		$('.ajax-loader.page-loader').show();
		updateProductListing($(this).find('option:selected').val());
	});

	//handle refinement change
	$('.filter .filter-option:not(.disabled)').on('click', function() {
		if($(this).hasClass('selected')) {
			updateProductListing($(this).data('url'));
		} else {
			updateProductListing($(this).data('refineurl'));
		}
	});

	$('.filter-link').on('click', function() {
		isSortingEnabled = false;
		$('.filter-contents').addClass('active');
		$('html').addClass('filter-open');
		// push event to datalayer when filter panel opened (only mobile)
		if(currLayout === 'mobile') {
			analytics.filterPanelOpened();
		}
	});

	$('.filter-close').on('click', function() {
		$('.filter-contents').removeClass('active');
		$('.filter-dropdowns .dropdown').removeClass('open');
		$('html').removeClass('filter-open');
		// push event to datalayer when filter panel closed (only mobile)
		if(currLayout === 'mobile') {
			analytics.filterPanelClosed();
		}
	});

	$('.filter-dropdowns .dropdown').on('click', function(e) {
		if(!$(e.target).hasClass('filter-option')) {
			$(this).toggleClass('open').siblings().removeClass('open');
		}
	});

	$('.selected-refinements .refinement').on('click', function() {
		updateProductListing($(this).data('relaxurl'));
	});

	$(document).mouseup(function(e) {
	    var activeDropdown = $('.filter-dropdowns .dropdown.open');
	    if ((window.innerWidth > 768) && !activeDropdown.is(e.target) && activeDropdown.has(e.target).length === 0) {
	    	activeDropdown.removeClass('open');
	    }
	});

	if($('.selected-refinement-url').text() > 0) {
		$('.filter-link').addClass('filter-applied').attr('data-filtercount', $('.selected-refinement-url').text());
	} else {
		$('.filter-link').removeClass('filter-applied');
	}

	var filterDropdowns = $('.filter-options-wrapper');
	for(var i = 0; i < filterDropdowns.length; i++) {
		if($(filterDropdowns[i]).find('.selected').length > 0) {
			$(filterDropdowns[i]).siblings('.filter-heading').addClass('bold');
		}
	}
}

function catShopByCollectionMenuInit() {
	$("#clp-collection-select").selectmenu({
		//Add class to Dropdown Set for css targeting
		width: false,
		position: {
			my: "left top",
			at: "left bottom-2",
			collision: "flip flip"
		},
		classes: {
			"ui-selectmenu-menu": "catShopByCollection"
		}
	});
}

function tileSelectSizeInit() {
	$(".product-swatches select").selectmenu({
		//Add class to Dropdown Set for css targeting
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		},
		classes: {
			"ui-selectmenu-menu": "pdp-color-select"
		}
	});
}

function simpleSearchClearFunc() {
	var $resetLink = $('.search-form-wrapper button[type="reset"]'),
		$submitButton = $('.search-form-wrapper button[type="submit"]'),
		$searchForm = $('form[name="searchPageSimpleSearch"]'),
		$searchInput = $('form[name="searchPageSimpleSearch"] input[type="text"]');
	$searchInput.on('input', function (e) {
		if ($(this).val().trim() == '') {
			$resetLink.hide();
		} else {
			$resetLink.show();
		}
	});
	$resetLink.on('click', function () {
		$searchInput.val('');
		$resetLink.hide();
		$submitButton.prop('disabled', true);
		$searchInput.trigger('focus');
		return false;
	});
	
	$submitButton.on('click', function (e) {
		e.preventDefault();
		$searchInput.val($searchInput.val().trim());
		$searchForm.submit();
	}.bind(this));
}

function viewMorePosition() {
	if ($('.renderbottommotiveimage').length > 0 && $('.pagination-buttons').length > 0) {
		if (!$('.exclusive-items + .pagination-buttons').length > 0) {
			$('.pagination-buttons').insertAfter(".exclusive-items");
		}
	}
}

function ellipsifyContentDesc(str, charlength) {
	if (str.length > charlength) {
		return (str.substring(0, charlength) + "...");
	} else {
		return str;
	}
}

function ellipsifyContentDescInt() {
	if (('.search-folder-content-list .tutorial-detail-link').length > 0) {
		$('.search-folder-content-list .content-description').each(function (index) {
			$(this).html(ellipsifyContentDesc($(this).html(), 62));
		});
	}
}

// sorting rule default selected
function rankDefaullSelected() {
	let rankDefaullValue = $("#grid-sort-header, #grid-sort-header-redesign").find(':selected').attr('value');
	let rankDefaullSelected = rankDefaullValue.match(/rule=rank/gi);

	if (rankDefaullSelected != undefined && $("#grid-sort-header, #grid-sort-header-redesign").find(':selected')) {
		$("#grid-sort-header, #grid-sort-header-redesign").find(':selected').trigger('change');
	}
}

 function viewMoreHandler() {
	$("#view-more").off();
	$("#view-more-content").off();

	$(document).on("click", "#view-more", viewMoreClick);
	$(document).on("click", ".wishlist .button.articles-view-more", viewMoreContent);
};

function updateFolderDescriptionOnChange() {
	if ($('.tutorial-select').length > 0) {
		var $tutorialdropdown = $('.tutorial-select');
		$tutorialdropdown.on('selectmenuchange', function (event, ui) {
			tutorialSelector(ui.item.value);
		});
		$tutorialdropdown.on('change', function() {
			tutorialSelector($(this).val());
			$(this).selectmenu('refresh');
		});
	}
}

function tutorialSelector(uiItem) {
	$('.tutorial-desc').html($(this).find(':selected').data('description'));
	if(!(uiItem == '')) {
		window.location = uiItem;
	}
} 

function groupingSelector() {
	$("#grouping-cat").selectmenu('refresh');
	$("#grouping-cat-sibling").selectmenu('refresh');
	$("#grouping-cat").on("selectmenuchange", function (event, ui) {
		updateGroupingSubcat(ui.item.value);	
	});
	$( "#grouping-cat" ).on( "change", function() {
		updateGroupingSubcat($(this).val());
	});
	$(document).on("selectmenuchange", "#grouping-subcat, #grouping-cat-sibling", function (event, ui) {
		updateGroupingSubcat(ui.item.value);
	});
	$( document ).on( "change", "#grouping-subcat, #grouping-cat-sibling",  function() {
	  	updateGroupingSubcat($(this).val());
	});
}

function updateGroupingSubcat(itemValue){
	if(!(itemValue == '')) {
		window.location = itemValue;
	}
}

function categoryCarousel() {
	if ($('#category-hero').children().length > 1) {
		$('#category-hero').slick({
			arrows: true,
			dots: true
		});
	}
}

function viewMoreContent() {
	$('.wishlist .ajax-loader').show();
	var gridUrl = $(this).attr('data-grid-url');
	$.ajax({
		type: 'GET',
		dataType: 'html',
		url: gridUrl,
		success: function (response) {
			$('.wishlist .ajax-loader').hide();
			$('.wishlist .article-bottom').replaceWith(response)
		}
	});
}

//Coup of viewMoreClick
function viewBottonToTopClick() {
	// getting the hidden div, which is the placeholder for the next page
	var backLoadingPlaceHolder = $('.infinite-scroll-placeholder-bottom-to-top[data-loading-state="unloaded"]');
	// get url hidden in DOM
	var gridUrl = backLoadingPlaceHolder.attr('data-grid-url');

	if (backLoadingPlaceHolder.length === 1) {
		// switch state to 'loading'
		// - switches state, so the above selector is only matching once
		// - shows loading indicator
		backLoadingPlaceHolder.attr('data-loading-state', 'loading');
		backLoadingPlaceHolder.addClass('infinite-scroll-loading');

		$('.back-page .inline-lazy-loader').show();

		// named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
		var fillEndlessScrollChunk2 = function (html) {
			$(".back-page").remove();
			var newHtml = $(html);

			backLoadingPlaceHolder.removeClass('infinite-scroll-loading');
			backLoadingPlaceHolder.attr('data-loading-state', 'loaded');
			
			$('#results-hits-bottom').remove();
			if ($('.tutorial-listing').length > 0) {
				$('div.search-result-content .folder-content-list').prepend(newHtml);
			} else if ($('.order-history-wrap').length > 0) {
				$('div.order-history-results').prepend(newHtml);
			} else {
				$('div.search-result-content').prepend(newHtml);
			}

			// move all product tiles up to search grid to prevent arbitrary breaklines
			$(".tiles-container .outer-wrapper").prependTo("#search-result-items");

			// If category bottom image configured then append bottom-empty li at last position(Exclusive Page)
			if ($('.renderbottommotiveimage').length) {
				$('.renderbottommotiveimage').appendTo("#search-result-items");
			}
			viewMorePosition();			

			$('img.product-image-initial').off().on('mouseenter mouseleave', function () {
				$(this).attr({
					src: $(this).attr('data-alt-src'),
					'data-alt-src': $(this).attr('src')
				});
			});
			// PLP wishlist heart icon
			wishListElem();
			// rebind the View More event
			$("#view-back").off().on("click", viewBottonToTopClick);
			tileSelectSizeInit();
			$("select").selectmenu().selectmenu('refresh', true);
			$('.back-page .inline-lazy-loader').hide();
			//$('#view-back').hide();
			$(".back-page").prependTo("#search-result-items");
			
			//remove next-page non required element
			var nextPageID = $("#search-result-items .outer-wrapper:first").attr("data-page-number");	
			$('#nextpage-'+nextPageID).remove();
			
			if ($('.search-result-items').is(':empty')) { 
			    $('.search-result-items').remove();
			}
			
			$('.product-tiles-holder').css('visibility','visible');			

			maintainBackPageScroll();  //maintain scrol position intact
		};

		// old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
		// it was removed to temporarily address RAP-2649
		if(gridUrl.length) {
			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: gridUrl,
				success: function (response) {
					// put response into cache
					try {
						sessionStorage['scroll-cache_' + gridUrl] = response;
					} catch (e) {
						// nothing to catch in case of out of memory of session storage
						// it will fall back to load via ajax
					}
					// update UI
					backLoadingPlaceHolder.remove(); // identifier to detect next page available or not					
					$(".results-hits").remove();
					$('.product-tiles-holder').css('visibility','visible');
					fillEndlessScrollChunk2(response);
					copyBottomResultHitsToTop();
					productTile.init();
					productTile.initCarouselSwatches();
					ellipsifyContentDescInt();
					$(document).trigger("plpviewmore");
					video.initialize();
					getPageUpdateOnUrl();
					// rebind lazyLoadingObserver after DOM updated
					setTimeout(function(){	
						if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
							initPLPSliderHandler();
						}
						initializeProductColorShadesSliderHandler();
						if (!!window.IntersectionObserver) {
						lazyLoadingBottomToTopObserver();
					} }, 1000);
				}
			});
		}	
	}
}

//maintain scroll postion
function maintainBackPageScroll(){
	 var divScroll = localStorage.getItem("tempProductPosition") != null ? localStorage.getItem("tempProductPosition") : localStorage.getItem("productPositionLastClicked");
	 	  
	 if(divScroll != null && $('#'+divScroll).offset() != undefined){
		 $('html, body').animate({scrollTop: $('#'+divScroll+" div").offset().top - $(".sticky-component").outerHeight() },  100);
	 }
	  
	  localStorage.setItem("tempProductPosition",document.getElementsByClassName("outer-wrapper")[0].id);
}

 //observer bottom to top - lazy loading
 function lazyLoadingBottomToTopObserverHandler(entries, observer) {
	 if ( !$( ".back-page" ).hasClass( "temp-hide" ) ) {
		for (var entry of entries) {
			if (entry.intersectionRatio>= 0.85) {
			viewBottonToTopClick(); 
			} 
		}
	}
}

 //on back button highlighting div
 function onReloadMaintainScroll(){
	 if (window.location.href.indexOf("#") > -1 && localStorage.getItem("productPositionLastClicked")) {
		 var divScroll = localStorage.getItem("productPositionLastClicked");
		 if($('#'+divScroll).offset() != undefined){
			$('html, body').animate({scrollTop: $('#'+divScroll+" div").offset().top - $(".sticky-component").outerHeight() },  100);
		}	  
		  
	  }
 }

 //Lazy loading - loading initialisation
 function postObserverAct(){
	 $('html').removeClass('disable-scroll');
	 $('.product-loader').removeClass('is-active');	
	 onReloadMaintainScroll();
	 $(".next-page").removeClass("temp-hide");
	 $(".back-page").removeClass("temp-hide");	 
	 	 
	 //initialize back to top scroll lazy load
	if (!!window.IntersectionObserver) {
		lazyLoadingBottomToTopObserver();
	}	
	// to check IntersectionObserver supports or not
	updateIntersectionObserverHandler();
	getPageUpdateOnUrl();	
 }
 
 //add Loader when PLP is back navigated
 function addLoader(){
	 if (window.location.href.indexOf("#") > -1 && localStorage.getItem("productPositionLastClicked")) {
		 $('html').addClass('disable-scroll');
	  }
 }

$(window).on('load', function () {
	localStorage.removeItem("tempProductPosition");
	setTimeout(postObserverAct, 500);
	if ($('.pt_product-search-result').length && $("#grid-sort-header, #grid-sort-header-redesign").find(':selected').filter("[value]").length > 0) {
        rankDefaullSelected();
    }
});

// re-initialize Einstein Recommendation carousel
function initEinsteinRecommendations() {
	$(window).on("load", function() {
		setTimeout(function() {
			recommendations.init();
			// to reinit recommended product's quantity dropdown 
			$('.carousel-recommendations select').selectmenu();
		}, 5000);	
	});
}

function screenResizeHandler() {
	// Store the window width
    var winWidth = $(window).width();

	$(window).on('resize orientationchange', function () {
		// to prevent calling of resize event in IOS devices while scrolling
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();            
			// Do stuff here
			var $recommendationCarousel = $('.recommendation-container .carousel-recommendations');			
			if ($recommendationCarousel.hasClass('slick-initialized')) {
				$recommendationCarousel.slick('destroy');
				recommendations.init();
				$('.carousel-recommendations select').selectmenu();
			}
        }
	});
}

var initializeProductColorShadesSliderHandler = function() {
    const isDesktop = window.matchMedia("(min-width: 890px)").matches;
	const isMobile = window.matchMedia("(max-width: 370px)").matches;
    const slideCount = isDesktop ? 8 : (isMobile ? 4 : 5);

    $(".pt_product-search-result .product-variations #pdp-swatches").each(function () {
        const slider = $(this);
        const totalSlides = $(this).find("li").length;
        const selectedSlideIndex = $(this).find("li.selected").index();

        if(totalSlides > slideCount && !$(this).hasClass("slick-initialized")) {
            let initialSlide = Math.max(selectedSlideIndex - 5, 0);
            $(slider).slick({
                initialSlide: initialSlide,
                autoplay: false,
                dots: false,
                arrows: true,
                infinite: true,
                variableWidth: false,
                slidesToShow: 8,
                slidesToScroll: 6,
                swipe: true,
                responsive: [
                    {
                        breakpoint: 890,
                        settings: {
                            initialSlide: Math.max(selectedSlideIndex - 2, 0),
                            slidesToShow: 5,
                            slidesToScroll: 4,
                        }
                    },
                    {
                        breakpoint: 375,
                        settings: {
                            initialSlide: Math.max(selectedSlideIndex - 1, 0),
                            slidesToShow: 4,
                            slidesToScroll: 3
                        }
                    }
                ]
            });
        }
		if(!$(this).hasClass("slick-initialized")) {
			slider.addClass("shades-display");
		}
    });
}

let initPLPSliderHandler = function () {
	// for each loop to initialize slider
	var isDesktop = window.matchMedia("(min-width: 1025px)").matches;
	$('.outer-wrapper .product-slick-track, .crosssell-recommendation-modal .product-slick-track').each(function () {
		var slider = $(this);
		if(!$(this).hasClass("slick-initialized")) {
			$(slider).slick({
				initialSlide: 0,
				autoplay: false,
				dots: false,
				arrows: true,
				infinite: false,
				speed: 150,
				slidesToShow: 1,
				fade: true,
                cssEase: 'linear',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
						arrows: false,
						dots: true,
						}
					}
				]
			});
		}// Initialize the Slick slider
		
		var timer;
		var manualNavigation = false;

		$(slider).on({
			/**
			 * If the user has not manually navigated, shows the second slide after a delay.
			 *
			 */
			mouseenter: function () {
				clearTimeout(timer);

				// If the user has not manually navigated, show the second slide
				if (manualNavigation !== true && isDesktop) {
					var currentIndex = slider.slick('slickCurrentSlide');
					if (currentIndex !== undefined) {
						timer = setTimeout(function () {
							if (currentIndex === 0) { // If the current slide is the first slide
								slider.slick('slickGoTo', 1); // Show the second slide
							}
						}, 100);
					}
				} 
			},
			mouseleave: function () {
				clearTimeout(timer);

				// If the user has not manually navigated, revert to the first slide
				if (manualNavigation !== true && isDesktop) {
					var currentIndex = slider.slick('slickCurrentSlide');
					if (currentIndex !== undefined) {
						timer = setTimeout(function () {
							if (currentIndex !== 0) { // If the current slide is not the first slide
								slider.slick('slickGoTo', 0); // Show the first slide
							}
						}, 100);
					}
				}
			}
		});

		/**
   * Sets a flag to indicate that the user has manually navigated the slider.
   * This is triggered when the user clicks on a slider arrow.
   */
		$(slider).on('click', '.slick-arrow', function () {
			if ($(this).length) { // Check if the element exists
				manualNavigation = true; // Set manual navigation flag
			}
		});
	});
}

export default  {
	init : function () {
	addLoader();
	backInStock.init();
	
	video.init(function () {
		initializeEvents();
	});

	filterPanel.init();
	compareWidget.init();
	productTile.init();
	initializeEvents();
	bindFilterSortRefinement();
	// content navigation title link
	$('.nav.content-navigation .accordion-title span').on('click', function () {
		window.location = $(this).data('url');
	});

	// content navigation dropdown redirect
	$('.nav.content-navigation select').on('change', function () {
		window.location = $(this).val();
	});
	
	//hide the empty filter section
	if ($('.filter-wrapper').length > 0 && $('.filter-wrapper').find('.level-1:not(".back-link")').length == 0) {
		$('.filter-wrapper').css({'visibility': 'hidden', 'pointer-events': 'none'});
		$('.filter-grid-view-wrapper').css({'display': 'none'});
		$('.sorting-wrapper').addClass('only-sort');
	}

	var $accordionToggle = $('.refinements .accordion-arrow');

	$accordionToggle.on('click', function (evt) {
		evt.preventDefault();

		$(this).next($('#category-level-2')).slideToggle();

		$(this).parent($('li')).toggleClass('expanded');
	});

	//Tutorial content featured carousel
	if ($('.tutorial-carousel-slick').length > 0) {
		$('.tutorial-carousel-slick').slick({
			arrows: true,
			dots: true,
			infinite: false
		});
	}

	recommendations.init();
	groupingSelector();
	categoryCarousel();
	simpleSearchClearFunc();
	viewMorePosition();
	ellipsifyContentDescInt();
	updateFolderDescriptionOnChange();
	initEinsteinRecommendations();
	screenResizeHandler();
	if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
		initPLPSliderHandler();
	}
	initializeProductColorShadesSliderHandler();
	},
	initPLPSlider : initPLPSliderHandler,
	initializeProductColorShadesSlider : initializeProductColorShadesSliderHandler,
	updateIntersectionObserver : updateIntersectionObserverHandler,
	viewMore : viewMoreHandler,
}